import React from 'react';
import SystemHealthDashboard from '@/components/admin/SystemHealthDashboard';

const SystemHealthPage = () => {
  return <SystemHealthDashboard />;
};

export default SystemHealthPage;
